export default {
  zh_CN: {
    0: "简体",
    1: "简体中文"
  },
  en_US: {
    0: "en",
    1: "English"
  },
  fr_FR: {
    0: "fr",
    1: "Français"
  },
  de_DE: {
    0: "de",
    1: "Deutsch"
  },
  it_IT: {
    0: "it",
    1: "Italiano"
  }
};
